'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'arrow-down-left-and-arrow-up-right-to-center';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e092';
var svgPathData = 'M381.4 176l121.4-121.4-45.3-45.3-121.4 121.4 0-82.7-64 0 0 192 192 0 0-64-82.7 0zM80.1 272l-32 0 0 64 82.7 0-121.4 121.4 45.3 45.3 121.4-121.4 0 82.7 64 0 0-192-160 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faArrowDownLeftAndArrowUpRightToCenter = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;